module.exports = __webpack_public_path__ + "rozwijanie.png?8d800c29e2591c166806a3f1628e7fb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rozwijanie.png
// module id = 1006
// module chunks = 2